export default "__VITE_ASSET__C$qarsLv__"